export const VIEW_LICENSE = "view"
export const COLLABORATE_LICENSE = "collaborate"
export const CREATE_LICENSE = "create"
export const REGIME_LICENSE = "regimes"
export const NO_LICENSE = "none"
